import styled from "styled-components";

export const ContentCalendarHome = styled.div`
  .event-past {
    background-color: ${({ theme }) => theme.primaryGray};
  }

  .react-calendar__navigation__prev2-button,
  .react-calendar__navigation__next2-button {
    display: none;
  }

  .react-calendar {
    width: 100%;
    border-right: 0;
    border-left: 0;
    border-top: 1px solid ${({ theme }) => theme.secondaryGrayLightNine};
    border-bottom: 1px solid ${({ theme }) => theme.secondaryGrayLightNine};
    padding: 32px 0 17px;
  }

  .react-calendar__navigation {
    height: initial;
    margin-bottom: 19px;
  }

  .react-calendar__month-view__weekdays__weekday {
    display: flex;
    padding: 7.354px 1.839px;
    justify-content: center;
    align-items: center;
    gap: 7.354px;
    flex: 1 0 0;
    margin-bottom: 14px;
  }

  .react-calendar__month-view__days {
    column-gap: 9.19px;
    justify-content: center;
  }

  .react-calendar__month-view__days__day {
    border-radius: 3.677px;
    margin-bottom: 14px;
    flex: 0 0 11.9999% !important;
    abbr {
      font-size: 14.708px;
      font-weight: 400;
      line-height: 14.708px;
    }
  }

  .react-calendar__month-view__days__day.react-calendar__tile {
    padding: 7.35px;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
    font-size: 11.951px;
    font-weight: 400;
    line-height: 14.708px;
    color: ${({ theme }) => theme.secondaryDarkOne};
    text-transform: capitalize;
  }

  .react-calendar__navigation__label__labelText {
    font-size: 18.385px;
    font-weight: 600;
    line-height: 18.385px;
  }

  .react-calendar__navigation__arrow {
    font-size: 18px;
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--now {
    background: ${({ theme }) => theme.button.primary};
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: ${({ theme }) => theme.button.primary};
    filter: opacity(0.8);
  }

  .react-calendar__tile--now abbr {
    color: white;
  }

  .event-future,
  .event-in-range {
    background: rgba(46, 46, 46, 0.1);
  }

  .event-day {
    border: 2px solid #f00;
    background-color: #ffd700;
  }

  .calendar-home_day {
    padding: 15px 0;
    color: ${({ theme }) => theme.button.primary};
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 0;
    span {
      color: ${({ theme }) => theme.secondaryDarkOne};
      margin-left: 4px;
    }
  }

  .calendar-home_list {
    padding: 8px 0 0;
    border-top: 1px solid ${({ theme }) => theme.secondaryGrayLightNine};
    li {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      padding: 5px 0 5px 22px;
      border-radius: 4px;
      background: ${({ theme }) => theme.secondaryGrayLightFour};
      list-style-position: inside;
      text-transform: capitalize;
    }
    li::marker {
      color: ${({ theme }) => theme.button.primary};
    }
  }

  .calendar-home_hour {
    float: inline-end;
    margin-right: 12px;
    color: #757575;
  }
`;

export const ContentDayEvents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const ButtonCreateEvent = styled.button`
  background-color: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-weight: bold;
  border-radius: 5px;
  border: none;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
